import {
    clearSpecial,
    clearSpecials,
    didReceiveSpecial,
    didReceiveSpecials,
    requestFailed,
    requestStarted,
    requestSucceeded
} from "./actions";

import SpecialRepository from "../_repositories/specialRepository";
import {plainToClass} from "class-transformer";
import {getCurrentUser} from "../_helpers/utils";
import Meta from "../_data/models/Meta";
import * as _ from "lodash";
import {ResourceType} from "../_helpers/data";
import {addDataAction} from "../_data/actions";
import {specialByIdSelector} from "../_data/selectors";

export function initializeSpecials() {
    return (dispatch) => {
        dispatch(clearSpecials());
        dispatch(fetchSpecialsByUser());
    }
}

export function initializeSpecial(id) {
    return (dispatch) => {
        dispatch(clearSpecial());
        dispatch(fetchSpecialBy(id));
    }
}

export function initializeSpecialsType(type) {
    return (dispatch) => {
        dispatch(clearSpecials());
        switch (type.toString()) {
            case "liked":
                dispatch(fetchLikedSpecialsByUser());
                break;
            case "expired":
                dispatch(fetchExpiredSpecialsByUser());
                break;
            default:
                dispatch(fetchSpecialsByUser());
                return;
        }
    }
}

export function fetchSpecialBy(id) {
    return (dispatch, getState) => {
        const special = specialByIdSelector(getState(), parseInt(id));
        if (!special) {
            dispatch(clearSpecial());
            dispatch(requestStarted());
            SpecialRepository.getById(id).then(data => {
                const {special} = data;
                if (data.error) {
                    return dispatch(requestFailed({requestErrors: ["Failed to retrieve styles."]}));
                }

                dispatch(addDataAction({
                    resource: ResourceType.special,
                    data: [special]
                }));

                dispatch(didReceiveSpecial({
                    id: special.id,
                }));

                return dispatch(requestSucceeded());
            });
        }
    }
}

export function fetchSpecialsByUser(cursor: number = null, page: number = null, perPage: number = 5) {
    return (dispatch, getState) => {
        dispatch(requestStarted());
        SpecialRepository.getByUserId(getCurrentUser(), cursor, page, perPage).then(data => {
            const {specials, meta} = data;
            if (data.error) {
                return dispatch(requestFailed({requestErrors: ["Failed to retrieve specials."]}));
            }

            let specialIds = _.map(specials, (each) => {
                return [each["id"], parseInt(each["id"])];
            });

            dispatch(addDataAction({
                resource: ResourceType.special,
                data: specials
            }));

            dispatch(didReceiveSpecials({
                ids: specialIds,
                meta: plainToClass(Meta, meta),
            }));

            return dispatch(requestSucceeded());
        });
    }
}

export function fetchExpiredSpecialsByUser(cursor: number = null, page: number = null, perPage: number = 5) {
    return (dispatch, getState) => {
        dispatch(requestStarted());
        SpecialRepository.getExpiredSpecialsByUserId(getCurrentUser(), cursor, page, perPage).then(data => {
            const {expired_specials, meta} = data;
            if (data.error) {
                return dispatch(requestFailed({requestErrors: ["Failed to retrieve specials."]}));
            }

            let specialIds = _.map(expired_specials, (each) => {
                return [each["id"], parseInt(each["id"])];
            });

            dispatch(addDataAction({
                resource: ResourceType.special,
                data: expired_specials
            }));

            dispatch(didReceiveSpecials({
                ids: specialIds,
                meta: plainToClass(Meta, meta),
            }));

            return dispatch(requestSucceeded());
        });
    }
}

export function fetchLikedSpecialsByUser(cursor: number = null, page: number = null, perPage: number = 5) {
    return (dispatch, getState) => {
        dispatch(requestStarted());
        SpecialRepository.getLikedSpecialsByUserId(getCurrentUser(), cursor, page, perPage).then(data => {
            const {liked_specials, meta} = data;
            if (data.error) {
                return dispatch(requestFailed({requestErrors: ["Failed to retrieve specials."]}));
            }

            let specialIds = _.map(liked_specials, (each) => {
                return [each["id"], parseInt(each["id"])];
            });

            dispatch(addDataAction({
                resource: ResourceType.special,
                data: liked_specials
            }));

            dispatch(didReceiveSpecials({
                ids: specialIds,
                meta: plainToClass(Meta, meta),
            }));

            return dispatch(requestSucceeded());
        });
    }
}


// WEBPACK FOOTER //
// ./app/client/special/middlewares.ts